import { render } from "./MyProjectPage.vue?vue&type=template&id=2f4d019a&scoped=true"
import script from "./MyProjectPage.vue?vue&type=script&lang=js"
export * from "./MyProjectPage.vue?vue&type=script&lang=js"

import "./MyProjectPage.vue?vue&type=style&index=0&id=2f4d019a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4d019a"]])

export default __exports__